import './LastSearch.css';

import React from 'react';

import { Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'LastSearch');

export function LastSearch({
    searchUrl,
    searchText
}: {
    searchText: string;
    searchUrl: string;
}) {
    return (<a
        target='_self'
        href={searchUrl}
        className={cn()}
    >
        <Icon size='s' color='rgba(74, 68, 97, 0.8)' name='clock-arrowed' />
        <div>
            <Typography
                className={cn('prefix-title')}
                variant='secondary-alone'
                color='secondary'
                tag='span'
            >
                Недавно вы&nbsp;искали:
            </Typography>
            <Typography
                className={cn('title')}
                variant='secondary-alone'
                color='primary'
                tag='span'
            >
                {searchText}
            </Typography>
        </div>
    </a>);
}
